<template>
  <div class="container">
    <img
      class="icon"
      :src="icon"
      :alt="text"
    />
    <p class="kds-typography-ui-strong-medium kds-color-text-secondary text">
      {{ text }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
})
</script>

<style scoped lang="scss">
.container {
  display: flex;
  padding: $kds-space-1x;
  align-items: center;
  gap: $kds-space-1-5x;
  align-self: stretch;
  border-radius: $kds-space-1-5x;
  background: $kds-color-background-subtle;

  .icon {
    width: 40px;
    height: auto;
  }

  .text {
    flex: 1 0 0;
  }
}
</style>
